module.exports = __webpack_public_path__ + "img/sq.14ce37a0.png";